export const background = "#ffffff"; // Background
export const foreground = "#333333"; // Foreground
export const primary100 = "#ebf5ff"; // Primary 100
export const primary200 = "#bfddfd"; // Primary 200
export const primary300 = "#97c6f8"; // Primary 300
export const primary400 = "#72aeef"; // Primary 400
export const primary500 = "#5097e3"; // Primary 500
export const primary600 = "#247ddc"; // Primary 600
export const primary700 = "#1b5ea5"; // Primary 700
export const primary800 = "#123f6e"; // Primary 800
export const primary900 = "#091f37"; // Primary 900
export const primaryBase = "#247ddc"; // Primary
export const secondary100 = "#f9faff"; // Primary 100
export const secondary200 = "#d0d4e1"; // Primary 200
export const secondary300 = "#9ea3b7"; // Primary 300
export const secondary400 = "#6e7694"; // Primary 400
export const secondary500 = "#3d4870"; // Primary 500
export const secondary600 = "#0d1a4c"; // Primary 600
export const secondary700 = "#0a1439"; // Primary 700
export const secondary800 = "#070d26"; // Primary 800
export const secondary900 = "#030511"; // Primary 900
export const secondaryBase = "#0d1a4c"; // Primary
export const success100 = "#e6f1ea"; // Success 100
export const success200 = "#b0d1b8"; // Success 200
export const success300 = "#7cb084"; // Success 300
export const success400 = "#4a8c4e"; // Success 400
export const success500 = "#196719"; // Success 500
export const success600 = "#185815"; // Success 600
export const success700 = "#164812"; // Success 700
export const success800 = "#13390e"; // Success 800
export const success900 = "#0f290a"; // Success 900
export const successBase = "#196719"; // Success
export const warning100 = "#fff7e6"; // Warning 100
export const warning200 = "#ffe4ac"; // Warning 200
export const warning300 = "#ffcf73"; // Warning 300
export const warning400 = "#ffb939"; // Warning 400
export const warning500 = "#ffa100"; // Warning 500
export const warning600 = "#d98600"; // Warning 600
export const warning700 = "#b36800"; // Warning 700
export const warning800 = "#8c4b00"; // Warning 800
export const warning900 = "#662f00"; // Warning 900
export const warningBase = "#ffa100"; // Warning
export const danger100 = "#f9eae7"; // Danger 100
export const danger200 = "#e9b9b3"; // Danger 200
export const danger300 = "#d68982"; // Danger 300
export const danger400 = "#c05854"; // Danger 400
export const danger500 = "#a72929"; // Danger 500
export const danger600 = "#8e2325"; // Danger 600
export const danger700 = "#751d20"; // Danger 700
export const danger800 = "#5c171a"; // Danger 800
export const danger900 = "#431114"; // Danger 900
export const dangerBase = "#a72929"; // Danger
export const neutral100 = "#f5f5f5"; // Neutral 100
export const neutral200 = "#e9e9e9"; // Neutral 200
export const neutral300 = "#d5d5d5"; // Neutral 300
export const neutral400 = "#bcbcbc"; // Neutral 400
export const neutral500 = "#a7a7a7"; // Neutral 500
export const neutral600 = "#767676"; // Neutral 600
export const neutral700 = "#333333"; // Neutral 700
export const neutral000 = "#ffffff"; // Neutral 000